<div class="wrapper">

    <h2>Rechercher les appels selon la période et le type d'intervention</h2>

    <form action="">

        <div id="paragraphe">
            <p>Choisir une période :</p>

            <mat-form-field> 
                <input matInput  [matDatepicker]="picker"
                    placeholder="début de contrat">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker startView="year" ></mat-datepicker>
            </mat-form-field>

            <mat-form-field> 
                <input matInput [matDatepicker]="picker1" placeholder="fin de contrat">
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1 startView="year" ></mat-datepicker>
            </mat-form-field>


        </div>

        <div id="paragraphe">
            <p>Type de contrat SAV :</p>
            <mat-form-field appearance="fill">
                <mat-label>Type</mat-label>
                <mat-select>
                    <mat-option>None</mat-option>
                    <mat-option *ngFor="let type of typesContrat" [value]="type">{{type}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div  id="paragraphe">
            <p>Type d'intervention :</p>
            <mat-form-field appearance="fill">
                <mat-label>Nom de l'intervention </mat-label>
                <input matInput placeholder="Ex. MES, Hotline..." >
              </mat-form-field>

        </div>

        <button type="submit" class="btn btn-primary">Valider</button>
    </form>

</div>